module.exports = __webpack_public_path__ + "static/media/arrow_forward_on.e168218a.svg";